/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} All_Translation_Jobs_StartedInputs */

const en_all_translation_jobs_started = /** @type {(inputs: All_Translation_Jobs_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`All ${i?.count} translation jobs started`)
};

const fr_all_translation_jobs_started = /** @type {(inputs: All_Translation_Jobs_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Toutes les ${i?.count} tâches de traduction ont été démarrées`)
};

const de_all_translation_jobs_started = /** @type {(inputs: All_Translation_Jobs_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Alle ${i?.count} Übersetzungsaufträge gestartet`)
};

const it_all_translation_jobs_started = /** @type {(inputs: All_Translation_Jobs_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tutti i lavori di traduzione ${i?.count} sono iniziati`)
};

const ru_all_translation_jobs_started = /** @type {(inputs: All_Translation_Jobs_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Все заказы на перевод ${i?.count} начались`)
};

const es_all_translation_jobs_started = /** @type {(inputs: All_Translation_Jobs_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se iniciaron todos los trabajos de traducción ${i?.count}`)
};

const zh_cn2_all_translation_jobs_started = /** @type {(inputs: All_Translation_Jobs_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`所有 ${i?.count} 翻译任务均已开始`)
};

const ja_all_translation_jobs_started = /** @type {(inputs: All_Translation_Jobs_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`すべての${i?.count}翻訳ジョブが開始されました`)
};

const hi_all_translation_jobs_started = /** @type {(inputs: All_Translation_Jobs_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`सभी ${i?.count} अनुवाद कार्य शुरू हो गए`)
};

const pt_pt2_all_translation_jobs_started = /** @type {(inputs: All_Translation_Jobs_StartedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Todos os trabalhos de tradução ${i?.count} começaram`)
};

/**
* | output |
* | --- |
* | "All {count} translation jobs started" |
*
* @param {All_Translation_Jobs_StartedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const all_translation_jobs_started = /** @type {((inputs: All_Translation_Jobs_StartedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<All_Translation_Jobs_StartedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_all_translation_jobs_started(inputs)
	if (locale === "de") return de_all_translation_jobs_started(inputs)
	if (locale === "it") return it_all_translation_jobs_started(inputs)
	if (locale === "ru") return ru_all_translation_jobs_started(inputs)
	if (locale === "es") return es_all_translation_jobs_started(inputs)
	if (locale === "zh-CN") return zh_cn2_all_translation_jobs_started(inputs)
	if (locale === "ja") return ja_all_translation_jobs_started(inputs)
	if (locale === "hi") return hi_all_translation_jobs_started(inputs)
	if (locale === "pt-PT") return pt_pt2_all_translation_jobs_started(inputs)
	return en_all_translation_jobs_started(inputs)
});